export default __webpack_public_path__ + "static/media/reach-out-of-us-illustration.2c931ca1.png";